import axios from 'axios';
import queryString from 'query-string';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

const apiPromise = (queryParams) => {
   return axios.get(`${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }/api/autoSuggest/getJobFeedHiringCompany?${ queryString.stringify(queryParams) }`);
};

const handleApiDataResponse = (data = []) => {
   return data.map(({ id, text, ...rest }) => ({
      id,
      name: text,
      label: text,
      ...rest,
   }));
};

export default withAutosuggestWrapper(withInputErrorMessage(autosuggestFactory({
   apiPromise,
   handleApiDataResponse,
   defaultPlaceholder: 'Search Hiring Company...',
})));
